var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCollections(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(6 7)",
    stroke: "#314E55",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    fill: "#81A4E3",
    d: "M0 0h16v47H0z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    fill: "#D8D8D8",
    d: "M4 4h8v7H4z"
  }), /*#__PURE__*/React.createElement("circle", {
    strokeLinecap: "round",
    fill: "#D8D8D8",
    cx: 8,
    cy: 38,
    r: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 15h5M4 20h8M4 25h8",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    fill: "#EA86A5",
    d: "M16 0h16v47H16z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    fill: "#D8D8D8",
    d: "M20 4h8v7h-8z"
  }), /*#__PURE__*/React.createElement("circle", {
    strokeLinecap: "round",
    fill: "#D8D8D8",
    cx: 24,
    cy: 38,
    r: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 15h8M20 20h5",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    fill: "#E4AD40",
    d: "M32 0h16v47H32z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    fill: "#D8D8D8",
    d: "M36 4h8v7h-8z"
  }), /*#__PURE__*/React.createElement("circle", {
    strokeLinecap: "round",
    fill: "#D8D8D8",
    cx: 40,
    cy: 38,
    r: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36 15h8M36 20h8",
    strokeLinecap: "square"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollections);
export default __webpack_public_path__ + "static/media/collections.f1608f73505901264759784dcc7dbe5c.svg";
export { ForwardRef as ReactComponent };